// abbreviation
export const STARTING_VOLUME_SORT = "Starting Vol.";
export const STARTING_CONCENTRATION_SORT = "Starting Conc.";
export const FINAL_VOLUME_SORT = "Final Volume";
export const FINAL_CONCENTRATION_SORT = "Est. Final Conc.";
export const VOLUME_TO_START_AT_SORT = "Start Exchange";
export const BUFFER_VOLUME_TO_USE_SORT = "Buffer Vol. To Use";

export const RESTORE_ALL_DEFAULT = "Restore All Defaults";
export const ADVANCED_SETUP = "Advanced Setup";
export const STARTING_VOLUME = "Starting Volume";
export const FINAL_VOLUME = "Final Volume";
export const REQUIRES_REFILL = "Requires Refill";
export const STARTING_CONCENTRATION = "Starting Concentration";
export const FINAL_CONCENTRATION = "Estimated Final Concentration";
export const VOLUME_TO_START_AT = "Sample Volume to Start Exchange";
export const EXCHANGE_PERCENTAGE = "Exchange Percentage";
export const EXCHANGE_VOLUME_NEEDED = "Necessary Exchange Volume";
export const STEP_SIZE = "Step Size";
export const BUFFER_VOLUME_TO_USE = "Buffer Volume To Use";
export const MEMBRANE_CUT_OFF_SIZE = "Membrane Cut Off Size";
export const MOLECULAR_WEIGHT_CUT_OFF_SIZE = "Molecular Weight Cut Off Size";
export const LEFT_CONICAL = "Left Conical";
export const CUSTOM_MANUAL_CONTROL = "Custom Volume";
export const PRESSURE = "Pressure";
export const MPES_PRESSURE = "mPES Pressure";
export const RC_PRESSURE = "RC Pressure";
export const VOLUME_THRESHOLD = "Value"; // "Volume Threshold";
export const ADD_NOTES = "Add Notes";
export const TOTAL_BUFFER_VOLUME_TO_USE = "Total Buffer Volume To Use";
export const CHIP_VALVE = "Chip Valve";
export const MORE_THAN_50_ML = {
  LABEL: "> 50 mL Volume",
  ON: "ON",
  OFF: "OFF",
};

// Diafiltration variables
export const DIAFILTRATION = "Buffer Exchange";
export const NONE_DIAFILTRATION = "None";
export const DISCRETE_DIAFILTRATION = "Discrete";
export const CONTINUOUS_DIAFILTRATION = "Continuous";
export const DIAFILTRATION_OPTION = {
  NONE: "None",
  DISCRETE: "Discrete",
  CONTINUOUS: "Continuous",
};
export const EXCHAGE_COUNT = "Exchange Count";
export const EXCHANGE_SIZE = "Step Size";

// AUTO PROFILE variable
export const CONCENTRATE = "Concentrate";
export const CONCENTRATION = "Concentration";
export const CONCENTRATION_MORE_50 = "Concentrate > 50 mL";
export const CONCENTRATION_MORE_THAN_50 = "Concentrate More Than 50 mL";
export const BUFFER_EXCHANGE = "Buffer Exchange";
export const STATUS_AND_GRAPH = "Status and Graph";
export const MANUAL_CONTROL = "Manual Control";
export const RECOVERY_FINISH = "Sample Recovery and Finishing";
export const CONC_TWO_TUBES = "Conc. Two Tubes";

export const STARTING_VOLUME_FIRST_TUBE = "Starting Volume of Left Tube";
export const STARTING_VOLUME_SECOND_TUBE = "Starting Volume of Right Tube";
export const TOTAL_BUFFER_VOLUME = "Total Buffer Volume";

// Manual Cycle
export const DEFAULT_MANUAL_PERIOD = "DEFAULT MANUAL PERIOD";
export const CUSTOME_TIME_PERIOD = "CUSTOME TIME PERIOD";
export const HOLD_TO_RUN = "HOLD TO RUN";

// Advance Setting variabel
export const DIAPHRAGM_VACUUM_PRESSURE = "Diaphragm Vacuum Pressure";
export const DIAPHRAGM_PRESSURE = "Diaphragm Pressure";
export const DIAPHRAGM_TIMING_OPEN = "Diaphragm Timing Open";
export const DIAPHRAGM_TIMING_CLOSE = "Diaphragm Timing Close";

// DIAPHRAGM_FILL_TIME and DIAPHRAGM_EMPTY_TIME to replace
// DIAPHRAGM_TIMING_OPEN and DIAPHRAGM_TIMING_CLOSE respectively
export const DIAPHRAGM_FILL_TIME = "Diaphragm Fill Time";
export const DIAPHRAGM_EMPTY_TIME = "Diaphragm Empty Time";

export const VALVE_TIMING = "Valve Delay";
export const PRIME_TIMING = "Prime Timing";
export const RECOVERY_TIMING = "Recovery Timing";
export const SEQUENCE_TIMING = "Sequence Timing";
export const RESET_PRESSURE_TIMMING = "RESET";
export const DURATION_OF_DIAFILTRATION = "Duration of Buffer Exchange";
export const DURATION_OF_PRIME = "Duration of Prime";
export const DURATION_OF_RECOVERY = "Duration of Recovery";

// setup page ext variabel
export const OPERATING_PRESSURE = "Operating Pressure";
export const RECOVERY_OF_LIQUID = "Recovery Of Liquid";
export const FLOW_RATE = "Flow Rate";
export const SKIP_PRIMING = "Skip Priming Sequence";
export const SKIP_PRIMING_OPTION = {
  ON: "ON",
  OFF: "OFF",
};
export const MEMBRANE_FILLING_CYCLE = "Membrane Filling Cycle";
export const MANUAL_CONTROL_THRESHOLD = "Safety Threshold";
export const VOLUME_CHANGE_THRESHOLD = "Volume Change Threshold";
export const NUMBER_OF_PUMPS = "Number of Pumps";
export const ESTIMATED_VOLUME_BUFFER = "Estimation Volume of Buffer Used";
export const ESTIMATED_FINAL_SAMPLE_VOLUME = "Est. Final Volume after Recovery";
export const DIAFILTRATION_CALCULATOR = "diafiltrationCalculatorButton";
export const APPROXIMATE_VOLUME = "Approximate Volume";
export const TARGET_VOLUME = "Target Volume";
export const SAFETY_THRESHOLD = "Safety Threshold";
export const PRIME_CHIP_WITH = "Prime Chip with";
export const PRIMING_VOLUME = "Priming Volume";
export const PRIME_CHIP_WITH_OPTION = {
  BUFFER: "BUFFER",
  SAMPLE: "SAMPLE",
};
export const AUTO_RECOVERY = "Auto Recovery";
export const HIGH_VOLUME_BUFFER = "High Volume Buffer";

// status
export const CURRENT_PRESSURE = "Current Pressure";
export const PUMP_FLOW_RATE = "Pump Flow Rate";
export const SAMPLE_VOLUME_FIRST_TUBE = "Sample Volume of Left Tube";
export const SAMPLE_VOLUME_SECOND_TUBE = "Sample Volume of Right Tube";
export const CURRENT_SAMPLE_VOLUME = "Current Sample Volume";
export const CURRENT_BUFFER_VOLUME = "Current Buffer Volume";
export const ESTIMATED_CONCENTRATION = "Estimated Final Concentration";
export const ESTIMATED_CURRENT_CONCENTRATION =
  "Estimated Current Concentration";
export const EST_CURRENT_CONCENTRATION = "Est. Current Concentration";
export const EST_CONCENTRATION_RATE = "Est. Concentration Rate";
export const ESTIMATED_CURRENT_BUFFER_VOLUME =
  "Estimated Current Buffer Volume";
export const EST_CURRENT_BUFFER = "Est. Current Buffer Volume";

// volume missmatch
export const SAMPLE_VOLUME = "Sample Volume";
export const EXCHANGE_VOLUME = "Exchange Volume";
export const BUFFER_VOLUME = "Buffer Volume";

// Sequence Runner
export const SOURCE_PRESSURE = "Valve Pressure";
export const VACUUM_PRESSURE = "Vacuum Pressure";
export const BOTTLE_PRESSURE = "Return Valve Pressure";

// Calibration Page
export const CALIBRATION_WEIGHT = "Calibration Weight";
export const SENSOR_MEASUREMENT_WEIGHT = "Sensor Measurement Weight";
export const SENSOR_MEASUREMENT_VOLUME = "Measured Volume";
export const CHECK_SCALES = "Check Scales";
export const CALIBRATE_SCALES = "Calibrate Scales";
export const MEASURES = "grams";
export const CALIBRATE = "Calibrate";
export const TARE = "Tare";
export const WEIGHT = "Weight";

export const EXPORT_SYSTEM_LOG = "Export System Logs";

// Timezone
export const TIMEZONE_AREA = "Geographic Area";
export const TIMEZONE_REGION = "City or Region";

export const PROFILE_HISTORY = {
  LIST_TABLE: {
    Active: "Active",
    Id: "Id",
    FileName: "FileName",
    ExportFileName: "ExportFileName",
    Date: "Date",
    Path: "Path",
    Profile: "Profile",
    Type: "Type",
    Status: "Status",
  },
  DETAIL_TABLE: {
    Date: "Date",
    Time: "Time",
    ElapsedTime: "ElapsedTime",
    Cycle: "Cycle",
    State: "State",
    SampleVolume: "SampleVolume",
    BufferVolume: "BufferVolume",
    Concentration: "Concentration",
    VacuumPressure: "VacuumPressure",
    ValvePressure: "ValvePressure",
    DiaphragmPressure: "DiaphragmPressure",
    ReturnValvePressure: "ReturnValvePressure",
    Notes: "Notes",
  },
};
export const LICENSE = {
  STATUS: {
    ACTIVE: "Active",
    EXPIRED: "Expired",
    NO_LICENSE: "NoLicense",
  },
  TYPE: {
    TEMPORARY: "Temporary",
    PERMANENT: "Instrument",
    UNKNOWN: "Unknown",
  },
  ERROR: {
    None: "None",
    NotActivated: "NotActivated",
    NotAuthentic: "NotAuthentic",
    Other: "Other",
    Expired: "Expired",
    InvalidDevice: "InvalidDevice",
    Invalid: "Invalid",
  },
};

export const ADV_BUTTON = {
  CONCENTRATE: "CONCENTRATE",
  BUFFER_EXCHANGE: "BUFFER EXCHANGE",
  PRIME: "PRIME",
  RECOVERY: "RECOVERY",
  MIXING: "MIXING",
};

// Mixing sequence
export const AUTO_MIXING = "Auto Mixing";
export const AUTO_MIXING_EVERY = "Auto Mixing Every";
export const AUTO_MIXING_EVERY_TITLE = "Mixing Cycle Every Minutes";
export const MIXING_CYCLE = "Mixing Cycle";
